import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../redux/actions'
import autobind from 'react-autobind'
import { withRouter, Redirect } from 'react-router-dom';
import Alert from './../components/Errors/Alert'
import Dropzone from 'react-dropzone';
import { Tooltip } from 'reactstrap';
import RegisterHeader from '../components/Register/Header'

class RegisterContactPage extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            profilePicture: props.profilePicture || null,
            phone: props.phone || "",
            phoneTooltip: false,
        };
        autobind(this)
    }

    componentDidMount() {
        this.props.resetRegistrationStep(2)
        document.title = "Register Contact Info"
    }

    componentWillReceiveProps(props) {
        const { phone, profilePicture, step2, error } = props
        if (step2) {
            return this.props.history.push("/register/payment-info")
        }
        this.setState({ phone, profilePicture, ...this.state, error })
    }

    onPhoneChange(event) {
        this.setState({ phone: event.target.value });
    }

    togglePhoneTooltip() {
        this.setState({
            phoneTooltip: !this.state.phoneTooltip
        })
    }

    onNextButtonClick() {
        const { phone, profilePicture } = this.state
        this.props.registerFlowStep2(phone, profilePicture);
    }

    onDropProfileImage(accepted) {
        this.setState({
            profilePicture: accepted[0]
        })
    }

    render() {

        const { phone, profilePicture, error } = this.state
        const { step1 } = this.props

        if (!step1) {
            return <Redirect to="/register" />
        }

        return (
            <div>
                <RegisterHeader />
                <div className="main-content main-content--register container">
                    <div className="row">
                        <div className="col">
                            <div className="panel panel--rounded panel-default mb-5">
                                <div className="panel-heading panel-heading--lg panel-heading-divider">
                                    Account Details
                            </div>
                                <div className="panel-body" style={{ paddingTop: 150, paddingBottom: 230 }}>
                                    {error ? (<div className="form-group row d-flex justify-content-center">
                                        <div className="col-sm-6">
                                            <Alert message={error} />
                                        </div>
                                    </div>) : null}

                                    <div className="form-group row mb-6">
                                        <label className="col-sm-4 col-form-label text-right" style={{ paddingRight: 70 }}>Photo / Logo</label>
                                        <div className="col-sm-5 d-flex justify-content-between align-items-center">
                                            <p className="mb-0">{profilePicture ? profilePicture.name : 'None (recommended size: 400x400px)'}</p>
                                            <Dropzone
                                                onDrop={(accepted, rejected) => { this.onDropProfileImage(accepted, rejected) }}
                                                className="btn btn-rounded btn-md-lateral-space btn-space btn-secondary mb-0">
                                                Upload
                                        </Dropzone>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right pr-6">Contact Phone</label>
                                        <div className="col-sm-5">
                                            <input type="text" placeholder="Phone" className="form-control" value={phone} onChange={this.onPhoneChange} />
                                        </div>
                                        <div className="col-sm-1 d-flex align-items-center justify-content-end">
                                            <span className="s7-info icon-info-box mr-5" id="phoneTooltip"></span>
                                            <Tooltip placement="top" isOpen={this.state.phoneTooltip} target="phoneTooltip" toggle={this.togglePhoneTooltip}>
                                                Info about phone number
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-center">
                                <button className="btn btn-rounded btn-space btn-transparent btn-lg-lateral-space mr-3" onClick={() => this.props.history.goBack()}>Back</button>
                                <button className="btn btn-rounded btn-space btn-primary btn-lg-lateral-space" onClick={this.onNextButtonClick}>Next</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const { registerFlow: { profilePicture, phone, error, step1, step2 } } = state
        return { profilePicture, phone, error, step1, step2 }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps);
    }
)(withRouter(RegisterContactPage))



// WEBPACK FOOTER //
// ./src/containers/RegisterContact.js